const { $, Limelight } = window;

const Cookie = require('js-cookie');

const ThemeSections = require('@shopify/theme-sections');

// require('../../styles/sections/theme-announcements.scss');

exports.default = () => { 
  ThemeSections.register('theme-announcements', {
    onLoad: function onLoad() {
      // Announcements Message slide up
      if ($('.offer').length > 1) {
        setInterval(() => {
          $('.offer').first().slideUp(function () {
            $(this).appendTo($(this).parent()).css({ overflow: '', display: '' });
          });
        }, 4400);
      }

      // Popup menu
      const DrawerNav = new Limelight('#DrawerNav', {
        bodyClass: 'active-drawer',
        hideCallback: function hideCallback(element) {
          // Hide all submenus on drawer close
          window.drawerMenus.forEach((elem) =>{
            elem.hide();
          });

          // Scroll back to top of all menus on drawer close
          const drawerScrolls = element.element.querySelectorAll('[data-scroll-state]');
          drawerScrolls.forEach((elem) => {
            elem.scrollTop = 0;
          });
        }
      });

      // Popup submenus
      const childDrawers = this.container.querySelectorAll('[data-trigger="drawer-menu"]');
      window.drawerMenus = [];

      childDrawers.forEach((drawer, index) => {
        window.drawerMenus[index] = new Limelight('' + drawer.dataset.target, {
          beforeShowCallback: function beforeShowCallback(element, elements) {
            drawer.closest('.theme-nav-links').classList.add('invisible');
            element.element.querySelector('[data-scroll-state]').scrollTop = 0;
          },
          beforeHideCallback: function beforeHideCallback(element, elements) {
            drawer.closest('.theme-nav-links').classList.remove('invisible');
          }
        });
      });

      // Popup currency on drawer
      const PopupCurrency = new Limelight('#PopupCurrency');

      // Announcement hide/show
      const themeAnnoucement = this.container.querySelector('[data-announcements-container]');
      const themeAnnoucementMessage = themeAnnoucement.dataset.message;
      const themeAnnoucementClose = this.container.querySelector('[data-trigger="announcement-hide"]');

      if (Cookie.get('theme-announcement') != themeAnnoucementMessage) {
        themeAnnoucement.classList.remove('xsmall-medium--hide');
      }

      if (themeAnnoucementClose) {
        themeAnnoucementClose.addEventListener('click', (event) => {
          event.preventDefault();
          themeAnnoucement.classList.add('xsmall-medium--hide');
          Cookie.set('theme-announcement', themeAnnoucementMessage, 30);

          const trigger = new Event('announcement:hide');
          document.dispatchEvent(trigger);
        });
      }
    }
  })
};
